import api from 'services/sale/proposal'

export const handleSave = async (values: any) => {
  let res = await api.create(values)

  return res?.data?.success
}
